/**
 * Custom lazy loading for images in slider
 * To target image add placeholder url in src attribute, original img url set in data-src attr.
 * @see SHARK-2492
 */

const observerConfig = {
  rootMargin: '0px 0px 5% 0px',
  threshold: 0,
};

const lazyLoadObserver = new IntersectionObserver(function (entries, self) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      preloadImage(entry.target);
      self.unobserve(entry.target);
    }
  });
}, observerConfig);

function preloadImage(img) {
  img.src = img.dataset.src;
}

const lazyImages = document.querySelectorAll('[data-src]');
lazyImages.forEach(img => {
  lazyLoadObserver.observe(img);
});
